import { LOCATIONS, ADD_LOCATION } from "../types/LocationType";

const initialState = {
  list: null,
};

const locationReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOCATIONS:
      return { ...state, list: action.payload };
    case ADD_LOCATION:
      return {
        ...state,
        list: Array.isArray(state.list) ? [...state.list, action.payload] : [action.payload],
      };
    default:
      return state;
  }
};

export default locationReducer;
